import { BrowserRouter, Routes, Route } from "react-router-dom";
import WhiteboardSpeedPaint from "./WhiteboardSpeedPaint";
import ProceduralMorphLoop from "./ProceduralMorphLoop";
import ASMRPeacefulScene from "./ASMRPeacefulScene";
import ASMRGhibliScene from "./ASMRGhibliScene";

import NavButtons from "./NavButtons"; // ✅ new

export default function App() {
  return (
    <BrowserRouter>
      <NavButtons />  {/* <-- Show navigation buttons */}
      <Routes>
        <Route path="/" element={<WhiteboardSpeedPaint />} />
        <Route path="/morph" element={<ProceduralMorphLoop />} />
        <Route path="/asmr" element={<ASMRPeacefulScene />} />
        <Route path="/asmr2" element={<ASMRGhibliScene />} />
      </Routes>
    </BrowserRouter>
  );
}
